import React, { useState } from "react";
import style from "../editUser/editUser.module.css";
// import Input from "../../components/Input";
import { callback } from "chart.js/dist/helpers/helpers.core";
import { useLocation, useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../components/toastMessage";
import axios from "axios";
import { BASE_URL } from "../../constants/Constants";
import BoxComponent from "../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../utils/axios";

const editUser = () => {
  const { state } = useLocation();
  const { user } = state
  const [formData, setFormData] = useState({
    fullName: user.name,
    employeeId: user.employeeId ?? '',
    mobile: user.mobile,
    email: user.email,
    securityRoles: user.role,
    isActive: user.active === 1,
  });

  // const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  const mobileNumberChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value.replace(/[^0-9]/g, ''),
    }));
  };

  const handleSubmit = (e: { preventDefault: () => void; }) => {
    e.preventDefault();
    // Handle form submission logic here, such as sending data to a server.
  };

  const navigate = useNavigate();

  const isValidMobile = (mobile: string): boolean => {
    // Adjust the regex pattern based on your specific requirements
    const mobilePattern = /^[0-9]{10}$/;
    return mobilePattern.test(mobile);
  };

  const isValidEmail = (email: string): boolean => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  // const onUpdate = () => {
  //   axios.patch(`${BASE_URL}/api/admin`,
  //     {
  //       name: formData.fullName,
  //       employeeId: formData.employeeId,
  //       mobile: formData.mobile,
  //       email: formData.email,
  //       role: formData.securityRoles,
  //       active: formData.isActive ? 1 : 0,
  //       user_id: user.user_id || ''
  //     })
  //     .then(function (response) {
  //       if (response?.data?.success === 0) {
  //         ErrorToast(response?.data?.message)
  //         return
  //       }
  //       SuccessToast('User Updated')
  //       navigate("/add-user")
  //       // handle success
  //       console.log(response);
  //     })
  //     .catch(function (error: any) {
  //       // handle error
  //       console.log(error);
  //     })
  //     .finally(function () {
  //       // always executed
  //     });
  // }

  const onUpdate = () => {
    // Validate mobile number
    if (formData.mobile && !isValidMobile(formData.mobile)) {
      ErrorToast('Please enter a valid 10-digit mobile number');
      return;
    }

    // Validate email
    if (formData.email && !isValidEmail(formData.email)) {
      ErrorToast('Please enter a valid email address');
      return;
    }

    _axios.patch(`${BASE_URL}/api/admin`,
      {
        name: formData.fullName,
        employeeId: formData.employeeId,
        mobile: formData.mobile,
        email: formData.email,
        role: formData.securityRoles,
        active: formData.isActive ? 1 : 0,
        user_id: user.user_id || ''
      })
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        SuccessToast('User Updated')
        navigate("/add-user")
        // handle success
        console.log(response);
      })
      .catch(function (error: any) {
        // handle error
        console.log(error);
        ErrorToast('Failed to update user');
      })
      .finally(function () {
        // always executed
      });
  }

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Validate mobile number
    if (name === 'mobile' && value && !isValidMobile(value)) {
      ErrorToast('Please enter a valid 10-digit mobile number');
    }

    // Validate email
    if (name === 'email' && value && !isValidEmail(value)) {
      ErrorToast('Please enter a valid email address');
    }
  };

  return (
    <div className={style.body}>
      <div className={style.divbodyheading}>
        <p className={style.bodytitle}>Edit User</p>
      </div>
      <form onSubmit={handleSubmit}>
        <BoxComponent>
          <div className={style.navbar}>
            <div className={style.userform}>
              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Name <span className="text-red-500">{' *'}</span></div>
                  <input
                    type="text"
                    id="name"
                    name="fullName"
                    placeholder="Full Name"
                    value={formData.fullName}
                    onChange={handleInputChange}
                  />
                </div>

                <div className={style.formgroup}>
                  <div className={style.loginText}>Employee ID (Optional)</div>
                  <input
                    type="text"
                    id="employeeId"
                    name="employeeId"
                    placeholder="Employee Id"
                    value={formData.employeeId ?? ''}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Mobile Number</div>
                  {/* <input
                  type="number"
                  id="mobile"
                  name="mobile"
                  placeholder="Enter Mobile Number"
                  value={formData.mobile}
                  onChange={(e) => e?.target.value.length < 11 ? mobileNumberChange(e) : {}}
                  onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                /> */}
                  <input
                    type="number"
                    id="mobile"
                    name="mobile"
                    placeholder="Enter Mobile Number"
                    value={formData.mobile}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                      setFormData({ ...formData, mobile: value });
                    }}
                  />
                </div>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Email ID</div>
                  <input
                    type="email"
                    id="emailId"
                    name="email"
                    placeholder="Enter Email ID"
                    value={formData.email}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className={style.formrow}>
                <div className={style.formgroup}>
                  <div className={style.loginText}>Access Level</div>
                  <select
                    id="securityRoles"
                    name="securityRoles"
                    className="selectwhite"
                    value={formData.securityRoles}
                    onChange={handleInputChange}
                  >
                    <option value="Level 1">Level 1</option>
                    <option value="Level 2">Level 2</option>
                    <option value="Level 3">Level 3</option>
                    <option value="System Admin">System Admin</option>
                  </select>
                </div>
                <div className={style.formgroup} >
                  <div className={style.footerActive}>
                    <label className={style.footerAct}>Activate User</label>
                    <div className={style.footerAct}>
                      <label className={style.toggleBtn}>
                        <input type="checkbox" checked={formData.isActive} onChange={() => setFormData({ ...formData, isActive: !formData.isActive })} className={style.inputCheckbox} />
                        <span className={style.slider}></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className={style.buttonSection}>
                <button
                  // className={style.publishButton}
                  className="buttonCss"
                  onClick={onUpdate}>
                  Save
                </button>
                <button
                  // className={style.closeButton}
                  className="closeButtonCss"
                  onClick={() => { navigate("/add-user") }}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </BoxComponent>
      </form>
    </div>
  );
};

export default editUser;
